export default __webpack_public_path__ + "excel-icon.svg";